import { render, staticRenderFns } from "./IdCardAuthCredit.vue?vue&type=template&id=4aa08a2a&scoped=true&"
import script from "./IdCardAuthCredit.vue?vue&type=script&lang=js&"
export * from "./IdCardAuthCredit.vue?vue&type=script&lang=js&"
import style0 from "./IdCardAuthCredit.vue?vue&type=style&index=0&id=4aa08a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa08a2a",
  null
  
)

export default component.exports